import { useTheme } from 'styled-components';

const useBlurDataUrl = () => {
	const theme = useTheme();

	const shimmer = (w?: number, h?: number) => `
            <svg width="${w ?? '100%'}" height="${
		h ?? '100%'
	}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <linearGradient id="g">
                <stop stop-color="${theme.colors.gray.gray15}" offset="0%" />
                <stop stop-color="${theme.colors.gray.gray10}" offset="50%" />
                <stop stop-color="${theme.colors.gray.gray15}" offset="100%" />
                </linearGradient>
            </defs>
            <rect width="${w ?? '100%'}" height="${h ?? '100%'}" fill="${
		theme.colors.gray.gray15
	}" />
            <rect id="r" width="${w ?? '100%'}" height="${h ?? '100%'}" fill="url(#g)" />
            <animate xlink:href="#r" attributeName="x" from="-${w ?? '100%'}" to="${
		w ?? '100%'
	}" dur="1s" repeatCount="indefinite"  />
            </svg>
        `;

	const toBase64 = (str: string) =>
		typeof window === 'undefined'
			? Buffer.from(str).toString('base64')
			: window.btoa(str);

	return [shimmer, toBase64] as [
		(w?: number, h?: number) => string,
		(str: string) => string,
	];
};

export default useBlurDataUrl;
